module.exports = __webpack_public_path__ + "static/media/manon.5cf5d2c0.jpg";